import React, {ReactNode} from "react";
import {Box, Colors, Text} from "@bounce/shared/ui";

const BLOCK_ICON_SIZE = 18;

type BlockIcon = React.FC<React.SVGProps<SVGSVGElement>>;

type BlockProps = {
  title: string;
  icon: BlockIcon;
  help?: string;
  action?: ReactNode;
  children: ReactNode;
};

export const PolicyBlock = ({title, icon: Icon, help, action, children}: BlockProps) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
      p: 2,
      border: `1px solid ${Colors.tertiary._300}`,
      borderRadius: "10px",
      backgroundColor: Colors.bw.white,
    }}
  >
    <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2}}>
      <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
        <Icon width={BLOCK_ICON_SIZE} height={BLOCK_ICON_SIZE} style={{color: Colors.grey._600, flexShrink: 0}} />
        <Text size={14} variant="inter600">
          {title}
        </Text>
      </Box>
      {action}
    </Box>
    {help && (
      <Text size={12} sx={{color: Colors.grey._600}}>
        {help}
      </Text>
    )}
    {children}
  </Box>
);

type ToggleButtonProps = {
  selected: boolean;
  onClick: () => void;
  children: ReactNode;
  ariaLabel?: string;
  minWidth?: number;
};

export const ToggleChipButton = ({selected, onClick, children, ariaLabel, minWidth}: ToggleButtonProps) => (
  <Box
    component="button"
    type="button"
    aria-pressed={selected}
    aria-label={ariaLabel}
    onClick={onClick}
    sx={{
      minWidth,
      height: 32,
      px: 1,
      borderRadius: "6px",
      border: `1px solid ${selected ? Colors.blue._400 : Colors.tertiary._300}`,
      backgroundColor: selected ? Colors.blue._100 : Colors.bw.white,
      color: selected ? Colors.blue._800 : Colors.grey._900,
      fontFamily: "inherit",
      fontSize: 13,
      fontWeight: selected ? 600 : 400,
      cursor: "pointer",
      transition: "background-color 150ms ease, border-color 150ms ease",
      "&:hover": {borderColor: selected ? Colors.blue._500 : Colors.tertiary._400},
    }}
  >
    {children}
  </Box>
);
